import { computed, reactive } from "vue";
import { authState } from "./auth";
import { locale } from "../locale";
import { findFirstByIds } from "./usersState";
import { speakersUpdate } from "./speakerInSharedState";

export const currentSpeakers = reactive<string[]>([]);

export const usersIdInPage = reactive<string[]>([]);

export const speakNotification = computed(() => {
  const users = currentSpeakers.filter(
    (id) => id !== authState.id && !usersIdInPage.includes(id),
  );
  if (users.length === 1) {
    const first = findFirstByIds(users)?.displayedName;
    if (first) return `${truncatedName(first, 40)} ${locale.speak}`;
    else return null;
  } else if (users.length > 1) {
    const first = findFirstByIds(users)?.displayedName;
    if (first) {
      return `${truncatedName(first, 40)} ${locale.and} ${
        users.length - 1
      } ${locale.speaks}`;
    } else return null;
  } else {
    return null;
  }
});

function truncatedName(name: string, maxLen: number) {
  if (name.length > maxLen) {
    return name.slice(0, maxLen) + "...";
  } else return name;
}

const timestamps: {
  [key: string]: number;
} = {};

export function setSpeakers(s: string[]) {
  speakersUpdate(s);
  s.forEach((c) => {
    if (c in timestamps) {
      clearTimeout(timestamps[c]);
      timestamps[c] = setTimeout(() => {
        delete timestamps[c];
        const fid = currentSpeakers.findIndex((el) => el === c);
        if (fid > -1) {
          currentSpeakers.splice(fid, 1);
        }
      }, 1500) as unknown as number;
    } else {
      currentSpeakers.push(c);
      timestamps[c] = setTimeout(() => {
        delete timestamps[c];
        const fid = currentSpeakers.findIndex((el) => el === c);
        if (fid > -1) {
          currentSpeakers.splice(fid, 1);
        }
      }, 1500) as unknown as number;
    }
  });
}
